/**
 * @typedef {object} _AbText_Props
 * @property {string|Symbol} text
 * @property {Object.<string, string>} [params]
 * @property {Object.<string, number>} [counts]
 * @property {boolean|'light'} emphasis
 */
export function AbText({ text, params, counts, emphasis }, { txt }) {
  text = typeof text === 'symbol' ? txt(text, params, counts) : text;
  if (typeof text === 'string') {
    return (
      <span className={`ab-text ${emphasis ? emphasis === 'light' ? 'ab-emphasis-light' : 'ab-emphasis-strong' : ''}`}
            dangerouslySetInnerHTML={{ __html: text }}/>
    );
  } else {
    return (
      <span className={`ab-text ${emphasis ? emphasis === 'light' ? 'ab-emphasis-light' : 'ab-emphasis-strong' : ''}`}>{ text }</span>
    );
  }
}
